import { Alert, Gold100 } from '@traceair/tds';
import FlakeIcon from '../../../../../images/components/FlakeIcon';
import { useAppStore } from '../../../../../store/appStore';
import { media, stylesheet } from 'typestyle';
import { useMemo } from 'react';
import { BREAKPOINT_SMALL } from '../../../../layout/styles';
import { RescheduleReason } from '../../../../../consts/RescheduleReason';
import { useWinterConditions } from '../../useWinterConditions';

const css = stylesheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    marginBottom: 16,
  },
  buttons: media(
    { maxWidth: BREAKPOINT_SMALL },
    {
      $nest: {
        '&&': {
          display: 'none',
        },
      },
    },
  ),
});

export const MissionWindowWinterConditions = () => {
  const { selectedMission, setSelectedDateChangeMission } = useAppStore();
  if (!selectedMission) return null;
  const { site, schedule } = selectedMission;

  const { winterElectionNotes, isShowWinterConditions } = useWinterConditions(site);

  if (!isShowWinterConditions) return null;

  const handleReschedule = () => {
    setSelectedDateChangeMission({
      mission: selectedMission,
      params: { initialReason: RescheduleReason.WinterCondition },
    });
  };

  const description = (
    <>
      Delay the mission if snow is present on site, as requested by the client.
      {winterElectionNotes && (
        <>
          <br />
          {winterElectionNotes}
        </>
      )}
    </>
  );

  const buttons = useMemo(
    () =>
      schedule
        ? [
            {
              text: 'Reschedule',
              onClick: handleReschedule,
              className: css.buttons,
            },
          ]
        : [],
    [schedule, handleReschedule],
  );

  return (
    <div className={css.container}>
      <Alert
        type={'attention'}
        icon={<FlakeIcon color={Gold100} />}
        title={'Mission with Winter conditions'}
        buttons={buttons}
        description={description}
      />
    </div>
  );
};
